import { useState, useMemo } from "react";
import { ContactForm } from "../../ContactForm/ContactForm";
import "./PageLayout.css";
import { DetailSidebar } from "../DetailSidebar/DetailSidebar";
import { ListingGrid } from "../ListingGrid/ListingGrid";
import {
  BaseLayoutKey,
  CardLayout,
  ListingPageLayoutProps,
} from "../../../types/ui-types";
import { TabsMap } from "../../Tabs/types";
import { TabLayout } from "../../Tabs/TabLayout";

export const LayoutEvent = ({
  listing,
  location,
  tabs,
  hasContactForm = false,
}: ListingPageLayoutProps) => {
  // STATE
  const [showContactForm, setShowContactForm] = useState(false);

  // VARS
  const cardLayout = cardLayoutByBaseLayout(listing.baseLayout);

  const tabsComponents: TabsMap = useMemo(() => {
    const tabEntries: TabsMap = Object.entries(tabs)
      .map(([key, connections]) => {
        const listings = connections.map((x) => x.listing);
        return {
          key: key,
          content: <ListingGrid listings={listings} layoutType={cardLayout} />,
        };
      })
      .reduce((acc, curr) => {
        return {
          ...acc,
          [curr.key]: {
            label: curr.key,
            content: curr.content,
          },
        };
      }, {});

    return tabEntries;
  }, [tabs]);

  return (
    <div className="listing-wrapper">
      {/* Cover Image */}
      {listing.coverImgUrl && (
        <div className="listing-cover-image">
          <img src={listing.coverImgUrl} alt={`${listing.name} cover`} />
        </div>
      )}

      <div className="listing-detail-container">
        {/* Sidebar */}
        <div className="layout__sidebar">
          <DetailSidebar
            listing={listing}
            location={location}
            hasContactForm={hasContactForm}
          />
        </div>

        {/* Main Content Area */}
        <div className="layout__main-content">
          <main className="listing-content">
            <TabLayout tabs={tabsComponents} />
          </main>
        </div>
      </div>

      {showContactForm && (
        <ContactForm
          recipientName={listing.name}
          recipientId={listing.id}
          onClose={() => setShowContactForm(false)}
        />
      )}
    </div>
  );
};

function cardLayoutByBaseLayout(
  baseLayout: BaseLayoutKey | undefined
): CardLayout {
  switch (baseLayout) {
    case "artist":
      return "artist";
    default:
      return "default";
  }
}
